import "./Terms.scss";

export default function Terms() {
  return (
    <section className="terms">
      <div className="title">
        <h3>Общи условия</h3>
      </div>
      <div className="text">
        <p>
          Настоящият документ съдържа Общите условия на договора за ползване на
          предоставяните от Алекс Фиш ООД услуги посредством уебсайт за онлайн
          поръчки<span> delivery.alexfish.bg</span> („Общите условия”) и урежда
          отношенията между Алекс Фиш ООД и всеки един от потребителите на
          уебсайта www.delivery.alexfish.bg.
          <br />
          <br />
          <span>І. ДЕФИНИЦИИ</span> <br />
          При тълкуването и прилагането на настоящите Общи условия използваните
          термини и изрази ще имат следното значение: <br />
          1.1. „IP Адрес” („IP address”) е уникален идентификационен номер,
          асоцииращ устройство, Интернет страница или ресурс на потребителя, по
          начин, който позволява локализирането им в глобалната Интернет мрежа.
          <br />
          1.2. Алекс Фиш ООД, (наричани по-долу Алекс Фиш ООД), е търговско
          дружество с <br />
          ЕИК: 201543727, със седалище и адрес на управление: жк ЛЕВСКИ ГРИГОРИЙ
          ЦАМБЛАК №20Б обл.СОФИЯ, гр.СОФИЯ 1517 <br />
          МОЛ: Александър Спасов, тел: +359 885 777 310, което предоставя
          услугите, предмет на настоящите Общи условия, посредством
          администрираният от него сайт: https://delivery.alexfish.bg.
          <br />
          1.3. Уебсайтът<span> delivery.alexfish.bg</span> е уебсайт посредством
          който на ПОТРЕБИТЕЛИТЕ се предоставя възможност за закупуване и
          доставка на храна до посочен от тях адрес. <br />
          1.4. „Електронна препратка” е връзка, обозначена в определена Интернет
          страница, която позволява автоматизирано препращане към друга Интернет
          страница, информационен ресурс или обект чрез стандартизирани
          протоколи. <br />
          1.5. „Злоумишлени действия” са действия или бездействия, нарушаващи
          Интернет етиката или нанасящи вреди на лица, свързани към Интернет или
          асоциирани мрежи, включително, но не само изпращане на нежелана поща
          (SPAM, JUNK MAIL), препълване на каналите (FLOOD), получаване на
          достъп до ресурси с чужди права и пароли, използуване на недостатъци в
          системите с цел собствена облага или добиване на информация (HACK),
          извършване на действия, които могат да бъдат квалифицирани като
          промишлен шпионаж или саботаж, повреждане или разрушаване на системи
          или информационни масиви (CRACK), изпращане на „троянски коне” или
          предизвикване инсталация на вируси или системи за отдалечен контрол,
          смущаване нормалната работа на останалите потребители на Интернет и
          асоциираните мрежи, както и извършване на каквито и да било действия,
          които могат да се квалифицират като престъпление или административно
          нарушение по българското законодателство или по друго приложимо право.
          <br />
          1.6. „Интернет страница” е част от уебсайт, която може да е съставна
          или обособена. <br />
          1.7. „Информационна система” е устройство или система от свързани
          устройства, което или някое от които е предназначено да съхранява,
          изпраща или получава електронни документи. <br />
          1.8. „ПОТРЕБИТЕЛ” е всяко лице с навършени 18 години, което ползва
          които и да е от предоставяните през уебсайта
          <span> delivery.alexfish.bg</span>
          услуги и ресурси. <br />
          1.9. „Потребителски профил” е обособена част в
          <span> delivery.alexfish.bg</span>, съдържаща информация за
          потребителя, предоставена от него при регистрацията му и съхранявана
          от<span> delivery.alexfish.bg</span>, като достъпът до потребителския
          профил се осъществява чрез въвеждане на потребителско име и парола.
          Профилът дава възможност на потребителя да разглежда и редактира
          данните, въведени при регистрацията, да има достъп до личната си
          пощеска кутия, да променя паролата си за достъп, да се абонира,
          съответно да се откаже от абонамента, за получаване на информационен
          бюлетин и др. <br />
          1.10. „Потребителско име” е избран от потребителя уникален код от
          букви и/или цифри, посредством които той се индивидуализира в
          <span> delivery.alexfish.bg</span> <br />
          1.11. „Парола” е избран от потребителя код от букви и/или цифри, който
          заедно с потребителското име индивидуализира същия. <br />
          1.12. „Потребителско съдържание” е всякакви данни, информация, текст,
          мненията и коментарите и блога, които ПОТРЕБИТЕЛЯТ разполага на
          <span> delivery.alexfish.bg</span> с оглед те да бъдат достъпни чрез
          Уебсайта
          <span> delivery.alexfish.bg</span> за всички останали ПОТРЕБИТЕЛИ.{" "}
          <br />
          1.13. „Сървър” е устройство или система от свързани устройства, на
          което или на някое от които е инсталиран системен софтуер за
          изпълняване на задачи във връзка със съхраняване, обработка, приемане
          или предаване на информация. <br />
          1.14. „Уебсайт” е обособеното място в глобалната Интернет мрежа,
          достъпно чрез своя унифициран адрес (URL) по протокол HTTP или HTTPS и
          съдържащо файлове, програми, текст, звук, картина, изображение,
          електронни препратки или други материали и ресурси. <br />
          1.15. „Блог” е Уебсайт, чието съдържание редовно бива допълвано с
          коментари, описания на събития, файлове и други информационни
          материали, представени в хронологичен ред. <br />
          1.16. „Случайно събитие” е непредвидено към момента на сключването на
          договора обстоятелство от извънреден характер, което прави
          изпълнението му обективно невъзможно. <br />
          1.17. „Търговски съобщения” са рекламни или други съобщения,
          представящи пряко или косвено стоките, услугите или репутацията на
          лице, извършващо търговска или занаятчийска дейност или упражняващо
          регулирана професия.
          <br />
          <br /> <span>ІI. ПРЕДМЕТ НА ДОГОВОРА</span> <br />
          2.1. Алекс Фиш ООД, чрез Уебсайта<span>
            {" "}
            delivery.alexfish.bg
          </span>{" "}
          предоставя в режим on-line на ПОТРЕБИТЕЛЯ предвидените в тези Общи
          условия услуги („Услугите”), при стриктно спазване от страна на
          последния на определените в тези Общи условия изисквания. <br />
          2.2. Част от Услугите на Уебсайта<span> delivery.alexfish.bg</span> се
          предоставят на всички ПОТРЕБИТЕЛИ без да е необходима предварителна
          регистрация. Такива са, без да се ограничават до: достъп до и
          използване, при спазване правилата на настоящите Общи условия, на
          разнообразни информационни ресурси, достъпни посредством Уебсайта
          <span> delivery.alexfish.bg</span> – новини, забавни публикации,
          промоции, календар с информация за предстоящи събития, обучения и
          семинари, каталог с електронни връзки към български и чуждестранни
          сайтове или друго предоставено от<span> delivery.alexfish.bg</span>{" "}
          съдържание, както и Потребителско съдържание, публикувано на Уебсайта
          <span> delivery.alexfish.bg</span>; <br />
          2.3. Използването на част от Услугите на Уебсайта
          <span> delivery.alexfish.bg</span>
          е възможно само след предварителна регистрация, създаване на
          Потребителски профил на ПОТРЕБИТЕЛЯ и въвеждане на потребителското име
          и паролата. <br />
          2.4. Отношенията между ПОТРЕБИТЕЛИТЕ и
          <span> delivery.alexfish.bg</span> във връзка с предлагането,
          осъществяването на достъп и използването на платени услуги посредством
          Уебсайта www.delivery.alexfish.bg се уреждат съгласно правилата,
          описани в Общите условия за ползване на съответните платени услуги,
          достъпни през Уебсайта
          <span> delivery.alexfish.bg</span>. <br />
          <br />
          <span>ІІІ. ПРИЛОЖНО ПОЛЕ. СЪГЛАСИЕ С ОБЩИТЕ УСЛОВИЯ</span>
          <br />
          3.1. Настоящите Общи условия се прилагат в отношенията с
          ПОТРЕБИТЕЛИТЕ, извършили регистрация на Уебсайта
          <span> delivery.alexfish.bg</span>
          („регистрираните ПОТРЕБИТЕЛИ”). Настоящите Общи условия се прилагат
          съответно и в отношенията с ПОТРЕБИТЕЛИТЕ, които не са извършили
          регистрация на уебсайта<span> delivery.alexfish.bg</span>{" "}
          („нерегистрираните ПОТРЕБИТЕЛИ”), като техните права са ограничени до
          ползване на услугите, описани в т. 2.2.
          <br />
          3.2. Текстът на настоящите Общи условия е достъпен в Интернет на
          интернет страница с адрес https://<span>
            {" "}
            delivery.alexfish.bg
          </span>{" "}
          по начин, който позволява неговото съхраняване и възпроизвеждане.
          Електронна препратка към Интернет страницата, съдържаща текста на
          настоящите Общи условия, е разположена на всяка страница от Уебсайта
          <span> delivery.alexfish.bg</span>. С всяко ползване на услугите и
          ресурси на Уебсайта<span> delivery.alexfish.bg</span>, включително с
          отварянето на Интернет страница от Уебсайта
          <span> delivery.alexfish.bg</span>, както и чрез натискане на
          електронна препратка от заглавната (началната) или която и да е друга
          Интернет страница на Уебсайта<span> delivery.alexfish.bg</span>,
          ПОТРЕБИТЕЛИТЕ декларират, че са запознати с настоящите Общи условия,
          съгласяват се с тях и се задължават да ги спазват.
          <br />
          3.3. За да може да използва услугите по т. 2.3. на настоящите Общи
          условия, ПОТРЕБИТЕЛЯТ трябва предварително да се регистрира, като
          попълни съответната електронна форма за регистрация, достъпна в реално
          време (on-line) в Интернет на страницата
          <span> delivery.alexfish.bg</span>. <br />
          3.3.1 В процеса на регистрация, чрез отбелязване в полето "Съгласен
          съм с Общите условия на<span> delivery.alexfish.bg</span> и натискане
          на виртуалния бутон "Регистрация", ПОТРЕБИТЕЛЯТ, съответно родителят
          или настойникът на ПОТРЕБИТЕЛЯ, извършва изрично електронно изявление
          по смисъла на Закона за електронния документ и електронния подпис, с
          което декларира, че е запознат с настоящите Общи условия, приема ги,
          съгласява се с тях и се задължава да ги спазва.
          <br />
          3.3.2 С регистрирането си ПОТРЕБИТЕЛЯТ получава достъп до всички
          предлагани от<span> delivery.alexfish.bg</span> услуги. При попълване
          на формата за регистрация ПОТРЕБИТЕЛЯТ, е длъжен да предостави пълни и
          верни данни относно самоличността си, съответно личността на
          ПОТРЕБИТЕЛЯ, и другите изискуеми от електронната форма на
          <span> delivery.alexfish.bg</span> данни, както и да ги актуализира
          незабавно при всяка тяхна промяна. ПОТРЕБИТЕЛЯТ, гарантира, че
          данните, които предоставя в процеса на регистрация, са верни, пълни и
          точни и при промяна на последните ще ги актуализира своевременно.
          <br />
          3.3.3 При непредоставяне на изискваните в регистрационната форма лични
          данни,<span> delivery.alexfish.bg</span> има право да откаже
          регистрацията. <br />
          3.3.4 В случай на предоставяне на неверни данни или неотразяване на
          настъпилите промени,<span> delivery.alexfish.bg</span> има право да
          прекрати или спре незабавно и без предизвестие предоставянето на
          Услугите, както и поддържането на регистрацията му. В този случай
          прекратяването на предоставянето на Услугите се счита за автоматично
          прекратяване на договора.
          <br />
          <br />
          <span>ІV. ПОТРЕБИТЕЛСКО ИМЕ И ПАРОЛА. ПОТРЕБИТЕЛСКИ ПРОФИЛ</span>
          <br /> 4.1. При регистрацията си ПОТРЕБИТЕЛЯТ посочва потребителско
          име и парола. Ако потребителското име не е вече заето, ПОТРЕБИТЕЛЯТ
          получава потребителското име и паролата, които е заявил. Чрез тях
          ПОТРЕБИТЕЛЯТ получава достъп до Потребителския си профил, както и
          възможност да ползва Услугите по т. 2.3. <br /> 4.2. Потребителското
          име представлява уникален код от букви, цифри и знаци, посредством
          които ПОТРЕБИТЕЛЯТ се индивидуализира при ползването на Услугите по т.
          2.3.<span> delivery.alexfish.bg</span> не проверява и не носи
          отговорност за съвпадението на потребителското име с името на
          ПОТРЕБИТЕЛЯ, за това дали то засяга права на трети лица и в частност
          право на име или други лични права, право на търговско наименование
          (фирма), право на запазена марка или други права на интелектуална
          собственост. <br /> 4.3. Паролата представлява код от букви, цифри и
          знаци, който заедно с потребителското име служи за достъп до определен
          потребителски профил.
          <br />
          4.4. ПОТРЕБИТЕЛЯТ е длъжен да не прави достояние на трети лица
          паролата си или тайните въпрос и отговор и да уведомява незабавно
          <span> delivery.alexfish.bg</span> в случай на неправомерен достъп,
          както и при вероятност от такъв. ПОТРЕБИТЕЛЯТ е длъжен да полага
          всички грижи и да предприема необходимите мерки, които разумно се
          налагат, с цел опазване на паролата си и на тайните въпрос и отговор и
          носи пълна отговорност за всички действия, които се извършват от него
          или от трето лице чрез използването им. <br />
          4.5. Потребителският профил представлява обособена част от Уебсайта
          <span> delivery.alexfish.bg</span>, съдържаща информация за
          регистрирания ПОТРЕБИТЕЛ, предоставяна в процеса на регистрация и
          съхранявана на сървър на<span> delivery.alexfish.bg</span>. Чрез
          потребителския си профил ПОТРЕБИТЕЛЯТ може да използва, настройва,
          активира или дезактивира използването на различни услуги по т. 2.3. на
          <span> delivery.alexfish.bg</span>, да управлява разположено от него
          на сървър на<span> delivery.alexfish.bg</span>
          Потребителско съдържание, да актуализира данните, предоставени при
          регистрацията си, да променя паролата си и тайните въпрос и отговор,
          да прекрати регистрацията си в<span> delivery.alexfish.bg</span> и др.{" "}
          <br />
          4.6. За да получи достъп до платените услуги на Уебсайта
          <span> delivery.alexfish.bg</span>, ПОТРЕБИТЕЛЯТ следва да извърши
          регистрация на обозначена за това Интернет страница или други
          действия, съгласно изискванията на посочените на страницата Общи
          условия за ползване на съответната платена услуга. <br />
          4.7. Всеки ПОТРЕБИТЕЛ може да има само един активен потребителски
          профил. Забранява се регистрацията под измислено име или под чуждо име
          (под чужда самоличност).<span> delivery.alexfish.bg</span> може да
          откаже регистрацията на лице, за което получи информация, че посочва
          неверни или чужди данни.
          <br />
          <br />
          <span>V. СКЛЮЧВАНЕ НА ДОГОВОРА</span>
          <br /> 5.1. Договорът между страните поражда действие от момента на
          постигане на съгласие, обективирано по начина, посочен в т. 3.2 или т.
          3.3.1. <br />
          5.2. Договорът се сключва на български език. <br />
          5.3. Договорът има действие: <br />
          а) За нерегистрираните ПОТРЕБИТЕЛИ – до преустановяване на ползването
          на Услугите по т. 2.2.; <br />
          б) за регистрираните ПОТРЕБИТЕЛИ – за неопределен срок от регистриране
          на ПОТРЕБИТЕЛЯ до прекратяването на договора по реда, предвиден в
          настоящите Общи условия. <br />
          <br />
          <span> VІ. ПРОМЕНИ В ОБЩИТЕ УСЛОВИЯ</span> <br />
          6.1. С оглед периодичното допълване и модификации на Услугите, тяхното
          усъвършенстване и разширяване, както и във връзка с възможни
          законодателни промени, които рефлектират върху тях, Общите условия
          могат да бъдат променяни едностранно от Алекс Фиш ООД. Тази промяна
          може да се извършва и при изменение на вида, естеството или
          технологията на предоставяните Услуги, при прекратяване предоставянето
          на определени Услуги, както и при изменение в икономическите условия.
          <br />
          6.2. При извършване на промени в Общите условия, Алекс Фиш ООД ги
          довежда до знанието на ПОТРЕБИТЕЛИТЕ чрез публикуването им на Уебсайта
          <span> delivery.alexfish.bg</span>. Алекс Фиш ООД предоставя на
          ПОТРЕБИТЕЛИТЕ двуседмичен срок да се запознаят с промените в Общите
          условия, след което те влизат в действие. <br />
          6.3. Тези Общи условия, както и бъдещи изменения в тях, се прилагат и
          за заварените регистрирани ПОТРЕБИТЕЛИ към датата на влизането им в
          действие. В срока по т. 6.2. те имат възможността да заявят чрез
          изпращане на съобщение до Алекс Фиш ООД, че отхвърлят промените. В
          случай, че изявление за отхвърляне на промените не бъде получено от
          Алекс Фиш ООД, се счита, че ПОТРЕБИТЕЛЯТ е обвързан от тях.
          Заявяването от страна на регистриран ПОТРЕБИТЕЛ, че не е съгласен с
          промените в Общите условия, ще води до автоматично прекратяване на
          договора между ПОТРЕБИТЕЛЯ и Алекс Фиш ООД за ползване на услугите,
          предоставяни чрез Уебсайта<span> delivery.alexfish.bg</span>, при
          което Алекс Фиш ООД има право да спре незабавно достъпа на съответния
          ПОТРЕБИТЕЛ до потребителския му профил, да прекрати регистрацията му и
          да изтрие от сървърите си цялото разположено от него Потребителско
          съдържание. <br />
          <br />
          <span>VІІ. ПРАВА И ЗАДЪЛЖЕНИЯ НА ПОТРЕБИТЕЛЯ</span> <br />
          7.1. ПОТРЕБИТЕЛЯТ сам осигурява необходимото му за ползването на
          предоставяните от Алекс Фиш ООД услуги клиентско оборудване (крайни
          устройства за достъп до Интернет и съответни софтуерни приложения) и
          достъп до Интернет. <br />
          7.2. ПОТРЕБИТЕЛЯТ има право на достъп в режим on-line до Услугите,
          предоставяни чрез Уебсайта<span> delivery.alexfish.bg</span>, при
          спазване на условията и изискванията за достъп, определени от Алекс
          Фиш ООД. <br />
          7.4. ПОТРЕБИТЕЛЯТ се задължава при ползване на предоставяните от Алекс
          Фиш ООД услуги да не зарежда, разполага на сървър на Алекс Фиш ООД и
          да не прави достояние по какъвто и да било начин на трети лица
          Потребителско съдържание – информация, данни, текст, съобщения, както
          и всякакви други материали или електронни препратки към материали: а.
          противоречащи на българското законодателство, приложимите чужди
          закони, настоящите Общи условия, Интернет етиката, правилата на морала
          и добрите нрави; б. съдържащи насилие (включително насилие над
          животни), агитация към насилие , унижение на човешкото достойнство,
          заплаха за живота и телесната неприкосновеност на човека; в. с
          порнографско или открито сексуално съдържание; д. съдържащи ясно
          различими тела на жертви от катастрофи и други тежки инциденти; е.
          обиждащи дадена религия или съдържащи религиозна агитация; ж.
          представляващи търговска или служебна тайна или друга конфиденциална
          информация; з. които са обект на право на интелектуална собственост на
          трети лица, освен със съгласието на титуляра на правото; и. нарушаващи
          каквито и да било имуществени или неимуществени права или законни
          интереси на трети лица; й. пропагандиращи дискриминация, основана на
          пол, раса, образователен ценз, възраст и религия или проповядващи
          фашистка, расистка или друга недемократична идеология; к. накърняващи
          доброто име на другиго и призоваващи към насилствена промяна на
          конституционно установения ред, към извършване на престъпление, към
          насилие над личността или към разпалване на расова, национална,
          етническа или религиозна вражда; л. съдържащи информация, подтикваща
          към или улесняваща извършването на терористична дейност; м. съдържащи
          информация за чужди пароли или права за достъп без съгласието на
          техния титуляр, както и софтуер за достъп до такива пароли или права;{" "}
          <br />
          7.5. ПОТРЕБИТЕЛЯТ се задължава при ползване на предоставяните от Алекс
          Фиш ООД услуги: а. да не извършва злоумишлени действия по смисъла на
          настоящите Общи условия; б. да уведомява незабавно Алекс Фиш ООД за
          всеки случай на извършено или открито нарушение при използване на
          предоставяните услуги; в. да не се представя за друго лице; д. да не
          използува методи, водещи до принудително зареждане на нежелано от
          Интернет-потребителите съдържание ("pop-up", "blind link" и други
          подобни). <br />
          7.6. ПОТРЕБИТЕЛЯТ има право по всяко време по своя собствена преценка
          да прекрати използването на предоставяните от Алекс Фиш ООД Услуги,
          като дезактивира предоставянето им от Потребителския си профил или
          друга посочена за целта интернет страница или прекрати регистрацията
          си на Уебсайта<span> delivery.alexfish.bg</span>, съответно
          преустанови използването на Услугите по т. 2.2. От момента на
          прекратяване на регистрацията, а за нерегистрираните ПОТРЕБИТЕЛИ – от
          момента на преустановяване ползването на услугите по т. 2.2.,
          договорът между страните се счита за автоматично прекратен, а Алекс
          Фиш ООД спира достъпа на съответния ПОТРЕБИТЕЛ до Потребителския му
          профил и има право да спре достъпа до и да изтрие от сървърите си
          цялото разположено от него Потребителско съдържание в съответствие с
          т. 14.2. от настоящите Общи условия. Дезактивирането на предоставяне
          на определени Услуги не води до прекратяване на договора. 7.7.
          ПОТРЕБИТЕЛЯТ може да осъществява достъп до и да използва каквото и да
          било съдържание, публикувано на Уебсайта
          <span> delivery.alexfish.bg</span>, включително до Потребителско
          съдържание, единствено за лично ползване с нетърговски цели при
          спазване изискванията на настоящите Общи условия. <br />
          7.8. ПОТРЕБИТЕЛЯТ се задължава да не осъществява и да не се опитва да
          придобива неоторизиран достъп до предоставяните от
          <span> delivery.alexfish.bg</span> услуги чрез прихващане и
          използуване на чужди пароли или каквито и да било други методи, да не
          заобикаля, поврежда или по друг начин да не смущава нормалната работа
          на технически или софтуерни приложения на Уебсайта
          <span> delivery.alexfish.bg</span>, които предотвратяват или
          ограничават достъпа до чужди електронни пощенски кутии,
          административни панели, компютърни системи и мрежи, свързани с
          предоставяните услуги. <br />
          <br />
          <span>VIII. ПРАВА И ЗАДЪЛЖЕНИЯ НА Алекс Фиш ООД</span> <br />
          8.1. Алекс Фиш ООД се задължава да полага дължимата грижа за
          предоставяне на възможност на ПОТРЕБИТЕЛЯ за нормално ползване на
          Услугите. Политика за приемане и удовлетворяване на рекламации на
          <span>AlexFish Delivery </span> Ние, <span>AlexFish Delivery </span>,
          обещаваме, че ще бъдем пред Вашата врата с поръчката Ви в рамките на
          срока, който е обявен, когато сте заявявали Вашата поръчка. НИЕ,{" "}
          <span>AlexFish Delivery </span> се ангажираме да доставим поръчката Ви
          до 75 мин. При висока натовареност, водеща до временно затруднение за{" "}
          <span>AlexFish Delivery </span> да спази посоченото време за доставка
          в района, където се намира адреса за доставка на ПОТРЕБИТЕЛЯ,
          <span>AlexFish Delivery </span> има право да откаже приемането на
          поръчката, като уведомява своевременно ПОТРЕБИТЕЛЯ, че поръчката му не
          може да бъде приета. <span>AlexFish Delivery </span> си запазва
          правото да променя районите на доставка и/или техните граници по своя
          преценка. <br />
          8.1.1. Условия за доставка по градове <br />
          8.1.2. Консумативи За всяка поръчана основна порция се полага по един
          безплатен прибор и безплатна кутия. При поръчка на порция суши се
          полага един безплатен комплект клечки за суши, ако желаете
          допълнително прибори или клечки е необходимо да ги заплатите.Комплект
          прибори (вилица, нож и лъжица) е на цена 0,20 лв, комплект клечки за
          суши е на цена 0,10 лв. При желание от страна на клиент за отделна
          кутия, допълнителният консуматив е на цена 0.49 лв. За хартиената
          опаковка, в която се доставя поръчката, се заплаща цена от 0,15 лв. В
          изпълнение стандартите за дейността на Доставчика, за една поръчка
          могат да бъдат използвани повече от една хартиени опаковки, в
          зависимост от вида и броя на артикулите. Промените в настоящите Общи
          условия се въвеждат в изпълнение изискванията на Директива (ЕС)
          2019/904 на Европейския парламент и на Съвета от 05.06.2019 г. относно
          намаляването на въздействието на определени пластмасови продукти върху
          околната среда (OBL 155 от 12.06.2019) и приетата с ПМС
          №354/26.10.2021г. в тази връзка Наредба за намаляване на въздействието
          на определени пластмасови продукти върху околната среда.
          <br /> 8.1.3. <span>AlexFish Delivery </span> гарантира, вкусовите
          характеристики и хранителни качества на доставените продукти по Вашата
          поръчка в рамките на 2 (два) часа, считано от момента на поръчката. С
          оглед на това <span>AlexFish Delivery </span> препоръчва да
          консумирате доставените Ви продукти в рамките на посочения по-горе
          срок. След този срок AlexFish Delivery не носи отговорност за
          вкусовите характеристики и хранителни качества на доставените
          продукти. <br />
          8.1.4. При констатиране на несъответствие между Вашата поръчка и
          доставените продукти в количествено и качествено отношение, Вие имате
          право да предявите рекламация, съгласно Закона за защита на
          потребителите. За Вашата рекламация е необходимо да ни уведомите в
          рамките на 60 мин., считано от часа на предаване на поръчката Ви, като
          уведомлението се счита за подадено, чрез обаждане по телефона на
          националния Център за приемане на поръчки с номер +359 885 777 310.
          Ако Вашето уведомление за рекламация е направено след този срок
          <span>AlexFish Delivery </span> не се задължава да следва политиката
          за приемане на рекламации. Разговорите към телефон +359 885 777 310 се
          таксуват на цената на един градски разговор, цената за който се
          определя от индивидуалния тарифен план на всеки потребител с
          телекомуникационната компания, чиито услуги ползва. <br />
          8.1.5. При предявяване на основателна рекламация от Ваша страна Ви
          предлагаме следните възможности за разрешаване на установения проблем
          в зависимост от ситуацията, вида и естеството на проблема: - Ако
          продуктът е пица, основно ястие, салата, бургер или тортила, детско
          меню, десерт, скара, предястие, сос, добавка към суши, гарнитура,
          напитка или хлебче ние ще Ви го заменим с нов, по-възможно най-бързия
          начин в рамките на същия ден или ще Ви предоставим ваучер, от който ще
          можете да се възползвате при следваща Ваша поръчка, който ще се
          равнява на стойността на сгрешения продукт. Ваучерът не може да бъде
          комбиниран с друг вид отстъпка. Ваучерът се използва за плащане на
          цялата поръчка или част от нея. Ваучерът се ползва еднократно, като не
          може да се ползва за плащане на две или повече поръчки. Ваучерът се
          предоставя за период от един месец ( 30- календарни дни) след
          получаването му. <br />
          8.1.6. Във всички случаи на неточно изпълнение на Вашата поръчка, с
          изключение на тези свързани с недоставен артикул/продукт, Вашата
          рекламация ще бъде призната за основателна, само ако представите на
          доставчика продукта, от който сте останали недоволни, в количество, не
          по-малко от две трети от доставеното. От друга страна, ако клиентът е
          изхвърлил поръчката или върне по-малко от две трети от предоставеното
          му количество, <span>AlexFish Delivery </span> не поема отговорност за
          компенсация.
          <br />
          8.1.7. Гаранциите за време не се отнасят до всички поръчки. Поръчки
          над 50€ изискват повече време за приготвяне и поради тази причина се
          налага удължаване времето на доставка. Всеки клиент ще бъде
          своевременно информиран за времето на доставка, докато прави своята
          поръчка или в последствие. <br />
          8.1.8. Настоящата Политика за приемане и удовлетворяване на
          рекламации, не се прилага при възникване на форсмажорни обстоятелства,
          в това число и при възникване на причини свързани с неблагоприятни
          метеорологични условия. <br />
          8.2. Алекс Фиш ООД няма задължението и обективната възможност да
          контролира начина, по който ПОТРЕБИТЕЛЯТ използва предоставяните
          Услуги, като не носи отговорност за целите и дейността на ПОТРЕБИТЕЛЯ
          във връзка с използване на Услугите, както и за вида и характера на
          Потребителското съдържание. Алекс Фиш ООД няма задължението да
          извършва наблюдение на информацията, съхранявана на сървърите му или
          направена достъпна при предоставяне на Услугите, нито да търси факти и
          обстоятелства, указващи извършването на неправомерна дейност от страна
          на ПОТРЕБИТЕЛЯ посредством ползването на Услугите. <br />
          8.3. В съответствие с изискванията на действащото българско
          законодателство Алекс Фиш ООД съхранява информационни материали и
          ресурси, разположени от ПОТРЕБИТЕЛЯ на сървър на
          <span> delivery.alexfish.bg</span>, и има право да ги предоставя на
          компетентните държавни органи в случаите, когато това е необходимо за
          запазване правата, законните интереси и сигурността на Алекс Фиш ООД
          или на трети лица, както и в случаите, когато същите са изискани от
          съответните държавни органи по надлежен ред. <br />
          8.4. В случай на неизползване на Потребителския профил на ПОТРЕБИТЕЛ в
          продължение на 60 дни след регистрацията или изтекат 120 дни от
          последното му използване, Алекс Фиш ООД има право да спре без
          предизвестие достъпа на съответния ПОТРЕБИТЕЛ до Потребителския му
          профил, да прекрати регистрацията му и да изтрие от сървърите си
          цялото разположено от него Потребителско съдържание. От момента на
          прекратяване на регистрацията договорът с ПОТРЕБИТЕЛЯ се счита за
          автоматично прекратен. <br />
          8.5. Алекс Фиш ООД има правото да поставя на всяка от страниците на
          Уебсайта<span> delivery.alexfish.bg</span>, включително в
          Потребителските профили, електронни препратки, рекламни банери и други
          рекламни форми за стоки и услуги, предлагани от Алекс Фиш ООД или
          трети лица, както и електронни препратки и рекламни банери, сочещи към
          уебсайтове, намиращи се извън контрола на Алекс Фиш ООД. Алекс Фиш ООД
          не носи отговорност за съдържанието, верността и законосъобразността
          на подобни Интернет страници или ресурси и на услуги или ресурси,
          които са станали достояние на ПОТРЕБИТЕЛЯ при ползването услугите на
          Уебсайта<span> delivery.alexfish.bg</span> <br />
          8.6. При активиране от страна на ПОТРЕБИТЕЛЯ на възможността за
          предлагане на рекламно място на блог, Алекс Фиш ООД има право, но не и
          задължение, по своя преценка да поставя на него материали по т. 8.5. В
          случай, че такива материали бъдат разположени на блога, Алекс Фиш ООД
          се задължава да предостави на ПОТРЕБИТЕЛЯ ...... % от получените от
          тази реклама приходи. <br />
          8.7. Алекс Фиш ООД има право да изпраща търговски съобщения до
          ПОТРЕБИТЕЛИТЕ, с цел да предложи информация и реклами относно свои
          собствени или оферирани от други търговски дружества стоки и/или
          услуги, да прави запитвания по най-различни въпроси, да провежда
          анкети и други. С приемането на настоящите Общи условия ПОТРЕБИТЕЛЯТ
          се съгласява да получава търговски съобщения от Алекс Фиш ООД. <br />
          8.8. Алекс Фиш ООД има право, но не и задължение, по своя преценка и
          без отправяне на предупреждение да спира достъпа до и/или да премахва
          Потребителско съдържание, когато същото противоречи на предвидените в
          настоящите Общи условия изисквания. <br />
          8.9. Алекс Фиш ООД няма задължението да спира достъпа до и/или да
          премахва Потребителско съдържание, публикувано в Уебсайта
          <span> delivery.alexfish.bg</span> по искане на ПОТРЕБИТЕЛЯ, който го
          е публикувал.
          <br />
          8.10. Алекс Фиш ООД има право по своя прeценка и без отправяне на
          предупреждение да спира или да ограничава временно достъпа на
          ПОТРЕБИТЕЛЯ до Услугите по т. 2.3., както и достъпа на други
          ПОТРЕБИТЕЛИ до разположено от него Потребителско съдържание, когато,
          по преценка на Алекс Фиш ООД или съгласно получена от трети лица
          информация, ПОТРЕБИТЕЛЯТ ползва Услугите в нарушение на българското
          законодателство, настоящите Общи условия, добрите нрави или други
          приложими норми. <br />
          8.11. Алекс Фиш ООД си запазва правото временно или трайно да
          преустановява предоставянето на конкретни Услуги, достъпни чрез
          Уебсайта<span> delivery.alexfish.bg</span>, като уведоми за това
          ПОТРЕБИТЕЛЯ със съобщение на съответните интернет страници или в
          Потребителския му профил. <br />
          8.12. ПОТРЕБИТЕЛЯТ има възможност да направи поръчка по телефона, чрез
          уебсайта https://delivery.alexfish.bg или чрез мобилното приложение
          <span>AlexFish Delivery </span> Mobile и да вземе приготвената поръчка
          в опаковано състояние, от избран от него ресторант. <br />
          8.13. ПОТРЕБИТЕЛЯТ получава:
          <br /> 8.14. За целите на определяне на необходимото време за
          приготвяне на поръчката, ПОТРЕБИТЕЛЯТ има възможност да маркира опция
          „сега“ или да посочи друг по-късен час, в който ще вземе поръчката.
          При маркиране на опция „сега“, приблизителното време за приготвяне на
          поръчката е ок. 25 минути, като в зависимост от моментната
          натовареност на избрания от ПОТРЕБИТЕЛЯ ресторант, този срок може да
          бъде удължен. При финализиране на поръчката, ПОТРЕБИТЕЛЯТ получава
          информация за очакваното време на приготвяне, след което има
          възможност да потвърди поръчката или да я да откаже, в случай, че не е
          съгласен с него. <br />
          8.15. ПОТРЕБИТЕЛЯТ е длъжен да се яви в съответния избран от него
          ресторант, до изтичане на очекваното време за приготвяне, за да приеме
          поръчката. При закъснение на ПОТРЕБИТЕЛЯ продължило повече от 15
          минути, Алекс Фиш ООД има право да се свърже с него за уточняване на
          причините за закъснението. При закъснение на ПОТРЕБИТЕЛЯ да вземе
          поръчката, което е продължило повече от 60 минути, Алекс Фиш ООД има
          право да анулира поръчката. <br />
          8.16. Условията на т.8.1.3, т.8.1.4., т.8.1.5., т.8.1.6. и т.8.1.7.
          по-горе, се прилагат и към поръчките „ВЗЕМИ ОТ РЕСТОРАНТА“/ „PICK UP“.
          <br />
          <br />
          <span>IХ. ИНТЕЛЕКТУАЛНА СОБСТВЕНОСТ</span> <br />
          9.1. С разполагането на Потребителско съдържание под каквато и да е
          форма на Уебсайта<span> delivery.alexfish.bg</span>, ПОТРЕБИТЕЛЯТ
          предоставя на Алекс Фиш ООД неизключителното право да го използва,
          записва, съхранява, разпространява публично в Интернет, включително да
          предлага достъп на неограничен брой лица до него по начин, позволяващ
          този достъп да бъде осъществен от място и по време, индивидуално
          избрани от всеки от тях, без да дължи възнаграждение за това и без
          териториални ограничения (за целия свят). Правото по предходната
          алинея се предоставя за времето, за което Потребителското съдържание е
          разположено на сървър на Алекс Фиш ООД, както и за разумен срок след
          премахването или изтриването му. <br />
          9.2. При използването на Услугите, предмет на настоящите Общи условия,
          ПОТРЕБИТЕЛЯТ има достъп до разнообразно съдържание и ресурси, които са
          обект на авторско право или други права на интелектуална собственост
          на Алекс Фиш ООД, на други ПОТРЕБИТЕЛИ или на съответно указаните
          лица. ПОТРЕБИТЕЛЯТ има достъп до съдържанието с оглед ползването му за
          лични нужди в съответствие с настоящите Общи условия и няма право да
          използва, записва, съхранява, възпроизвежда, променя, адаптира или
          разпространява публично обекти на интелектуална собственост, които са
          му станали достъпни при ползването на Услугите, освен ако се касае за
          незначителна по обем информация, предназначена за лично ползване, при
          условие, че не се увреждат неоправдано законните интереси на авторите
          или други носители на права на интелектуална собственост, в случай, че
          копирането или възпроизвеждането се извършват с нетърговска цел, както
          и в случай, че съответното съдържание е предоставено от него или е
          получил изричното съгласие на съответните правоносители. Независимо от
          горното ПОТРЕБИТЕЛЯТ няма право да премахва знаците за търговска марка
          и принадлежност на друго право на интелектуална собственост от
          достъпните му материали, независимо дали носителят на съответните
          права е Алекс Фиш ООД или друг ПОТРЕБИТЕЛ. <br />
          9.4. Правата на интелектуална собственост върху всички обекти на
          интелектуална собственост – материали, бази данни и други ресурси,
          разположени на Уебсайта, извън Потребителското съдържание, разположено
          от ПОТРЕБИТЕЛИТЕ на Уебсайта<span> delivery.alexfish.bg</span>, са
          обект на закрила съгласно Закона за авторското право и сродните му
          права и/или Закона за марките и географските означения, принадлежат на
          Алекс Фиш ООД или на съответно указаното лице, преотстъпило правото на
          ползване на Алекс Фиш ООД и не могат да бъдат използвани в нарушение
          на действащото законодателство. <br />
          9.5. В случай, че ПОТРЕБИТЕЛЯТ счита, че негови права на интелектуална
          собственост са нарушени от друг потребител, той следва да уведоми
          Алекс Фиш ООД в писмена форма на посочения в настоящите Общи условия
          адрес на управление или чрез писмо, изпратено на адреса на електронна
          поща, посочен за контакт с Алекс Фиш ООД. Уведомлението следва да
          съдържа точно идентифициране на материала, за който се твърди, че е
          публикуван в нарушение на права на интелектуална собственост,
          посочване на лицето или лицата, чиито права на интелектуална
          собственост са нарушени и основанието, на което тези лица са станали
          носители на съответните права, както и адрес и телефон за контакт с
          ПОТРЕБИТЕЛЯ. Алекс Фиш ООД по своя преценка предприема действията,
          посочени в т. 11.1. на настоящите Общи условия. <br />
          <br />
          <span>Х. ОТГОВОРНОСТ. ОГРАНИЧАВАНЕ НА ОТГОВОРНОСТТА </span>
          <br />
          10.1. Алекс Фиш ООД полага грижи за предоставяне на възможност на
          ПОТРЕБИТЕЛЯ за нормално ползване на Услугите, но доколкото
          предоставянето им е безплатно няма задължението и не гарантира, че те
          ще удовлетворят изискванията на ПОТРЕБИТЕЛЯ, нито че ще бъдат
          непрекъснати, навременни или сигурни. С приемане на настоящите Общи
          условия, ПОТРЕБИТЕЛЯТ декларира, че използването на предоставяните
          Услуги ще бъде изцяло на негов риск и отговорност, а страните се
          съгласяват, че Алекс Фиш ООД не отговоря за евентуално причинени на
          ПОТРЕБИТЕЛЯ при ползване на предоставяните Услуги вреди. <br />
          10.3. Алекс Фиш ООД не носи отговорност за наличността и качеството на
          стоки и съдържанието на услуги, поставени на вниманието на ПОТРЕБИТЕЛЯ
          чрез публикуване на Уебсайта на електронни препратки, рекламни банери
          и съобщения за продажба на стоки и предоставяне на услуги от трети
          лица и/или чрез прикачване на такива към текста на търговските
          съобщения, изпращани му на адреса на електронна пощенска кутия,
          посочен от него при регистрацията му или генериран при регистрацията
          му. Доколкото действията на тези трети лица не са под контрола на
          Алекс Фиш ООД, то същото не носи отговорност за противоправния
          характер на дейността на третите лица или за възникването,
          гарантирането, изпълнението, изменението и прекратяването на поети
          задължения и ангажименти във връзка с предлаганите от третите лица
          стоки и услуги, както и не отговаря за претърпени вреди и пропуснати
          ползи, произтекли от тези отношения. <br />
          10.4. Алекс Фиш ООД не носи отговорност за непредоставяне на услугите
          при настъпване на обстоятелства извън неговия контрол – в случаи на
          непреодолима сила, случайни събития, проблеми в глобалната мрежа
          Интернет и в предоставянето на услуги извън контрола на Алекс Фиш ООД,
          проблеми, дължащи се на оборудването на ПОТРЕБИТЕЛЯ, както и при
          случай на нерегламентиран достъп или интервенция на трети лица във
          функционирането на информационната система или сървърите на Алекс Фиш
          ООД. <br />
          10.5. Алекс Фиш ООД не носи отговорност за вреди, причинени на
          софтуера, хардуера или съоръженията на ПОТРЕБИТЕЛЯ, или за загуба на
          данни, произтекли от материали или ресурси, търсени, заредени или
          използвани по какъвто и да било начин посредством предоставяните
          Услуги. <br />
          10.6. Алекс Фиш ООД не носи отговорност спрямо ПОТРЕБИТЕЛЯ и трети
          лица, за претърпени вреди и пропуснати ползи, настъпили вследствие
          прекратяване, спиране, променяне или ограничаване предоставянето на
          която и да било от Услугите, предоставено за ползване на Услугите,
          изтриването, връщането, неполучаването, модифицирането, загубването,
          недостоверността, неточността, или непълнотaта на артикули, съобщения,
          материали или информация, използвани, записвани или станали достъпни
          чрез Уебсайта<span> delivery.alexfish.bg</span>. <br />
          10.7. Страните приемат, че Алекс Фиш ООД не носи отговорност за
          непредоставянето на Услугите или предоставянето им с влошено качество
          в следствие на извършвани тестове от страна на Алекс Фиш ООД с цел
          проверка на оборудване, връзки, мрежи и други, както и тестове,
          насочени към подобряване или оптимизиране на предоставяните Услуги. В
          тези случаи Алекс Фиш ООД предварително уведомява ПОТРЕБИТЕЛЯ за
          възможното временно непредоставяне, съответно за влошеното качество на
          Услугите. <br />
          10.8. С приемането на настоящите Общи условия ПОТРЕБИТЕЛЯТ декларира,
          че осъзнава възможността за евентуални прекъсвания и друг вид
          затруднения при осъществяване на Интернет връзката до Уебсайта
          <span> delivery.alexfish.bg</span>, които могат да възникнат
          независимо от положената от страна на Алекс Фиш ООД грижа.
          ПОТРЕБИТЕЛЯТ декларира, че няма да претендира каквито и да било
          обезщетения от Алекс Фиш ООД за пропуснати ползи, претърпени вреди или
          неудобства, вследствие настъпване на посочените по-горе прекъсвания
          или затруднения на Интернет връзката, включително и по отношение на
          капацитета на тази връзка. <br />
          10.9. Алекс Фиш ООД не носи отговорност и не дължи обезщетение на
          лице, чиито лични данни са използвани от друго лице за ползването на
          Услугите, предоставяни от Алекс Фиш ООД, независимо дали е дало или не
          съгласие за това.
          <br />
          <br />
          <span>
            ХІ. ПРАВА НА Алекс Фиш ООД В СЛУЧАЙ НА НЕИЗПЪЛНЕНИЕ НА ЗАДЪЛЖЕНИЯ НА
            ПОТРЕБИТЕЛ
          </span>{" "}
          <br />
          11.1. Алекс Фиш ООД има правото да спре, ограничи или промени
          предоставяните на ПОТРЕБИТЕЛЯ Услуги, както и да сезира компетентните
          държавни органи, ако с поведението си ПОТРЕБИТЕЛЯТ, по преценка на
          Алекс Фиш ООД, нарушава разпоредби на действащото българско
          законодателство, на настоящите Общи условия или правата и законните
          интереси на трети лица, както и по всяко време и без предварително
          предупреждение да спре достъпа до всяко съдържание, разположено на
          Уебсайта<span> delivery.alexfish.bg</span> от ПОТРЕБИТЕЛЯ, за което
          прецени или получи сведения от трети лица, че противоречи на
          действащото българско законодателство, на настоящите Общи условия или
          на техни или чужди права и законни интереси, включително права на
          интелектуална собственост, до разрешаването на подобен спор с акт на
          компетентен държавен орган. <br />
          11.2. При получаване на разпореждане от компетентни държавни органи,
          касаещо Потребителско съдържание, Алекс Фиш ООД има правото без
          предварително предупреждение да спре достъпа до такова Потребителско
          съдържание или да извърши други действия, съгласно полученото
          разпореждане. <br />
          11.3. Алекс Фиш ООД има правото без предизвестие да дезактивира
          паролата за достъп до потребителския профил на ПОТРЕБИТЕЛЯ в случай,
          че по преценка на Алекс Фиш ООД ПОТРЕБИТЕЛЯТ нарушава разпоредби на
          действащото българско законодателство, на настоящите Общи условия или
          правата и законните интереси на трети лица. В тези случаи Алекс Фиш
          ООД има право да прекрати регистрацията на ПОТРЕБИТЕЛЯ, да преустанови
          предоставянето на ПОТРЕБИТЕЛЯ на Услугите по т. 2.3. и да изтрие от
          сървърите си цялото разположено от него Потребителско съдържание.
          Договорът с ПОТРЕБИТЕЛЯ се счита за автоматично прекратен от датата на
          прекратяване на регистрацията му. <br />
          11.4. Когато получи информация, която дава достатъчно основания да се
          предположи, че поведението на ПОТРЕБИТЕЛЯ при ползването на Услугите
          на Уебсайта<span> delivery.alexfish.bg</span> от ПОТРЕБИТЕЛЯ би могло
          да представлява престъпление или административно нарушение, Алекс Фиш
          ООД има правото по своя преценка да сезира компетентните държавни
          органи, като им предоставя необходимото съдействие и цялата необходима
          информация и материали, изискани по надлежния ред, които по преценка
          на съответния орган биха помогнали за идентифициране на извършителя и
          доказване на извършеното престъпление или административно нарушение.
          <br />
          11.5. В горните случаи Алекс Фиш ООД не носи отговорност за претърпени
          вреди и пропуснати ползи от ПОТРЕБИТЕЛЯ или трети лица, настъпили
          вследствие спирането, променянето или ограничаването на Услугите,
          прекратяването на договора или предоставяне на информация или
          изпълнение на разпореждания на компетентните държавни органи. <br />
          <br />
          <span>ХІІ. ОБЕЗЩЕТЕНИЯ</span> <br />
          12.1. ПОТРЕБИТЕЛЯТ е длъжен да обезщети Алекс Фиш ООД и всички трети
          лица за всички претърпени от тях вреди и пропуснати ползи, включително
          за платени имуществени санкции, адвокатски възнаграждения и други
          разходи, вследствие на предявени искове от и/или платени обезщетения
          на трети лица във връзка с материали, които ПОТРЕБИТЕЛЯТ е направил
          достояние на трети лица или е направил достъпни чрез ползване на
          предоставените от Алекс Фиш ООД Услуги в нарушение на българското
          законодателство, приложимите чужди закони, настоящите Общи условия или
          добрите нрави, както и във връзка с други нарушения на задълженията му
          по настоящите Общи условия. <br />
          12.2. Вън от горното, ПОТРЕБИТЕЛЯТ се задължава да обезщети Алекс Фиш
          ООД за всички вреди, причинени вследствие ползване на предоставените
          Услуги от трети лица, на които последният е предоставил паролата си
          или тайните въпрос и отговор в нарушение на настоящите Общи условия.
          <br />
          12.3. Родителите, упражняващи родителски права, настойниците или
          попечителите на ненавършило пълнолетие лице, отговарят за всички
          вреди, причинени от същото на Алекс Фиш ООД и на трети лица при
          регистрацията и ползването на Услугите – предмет на настоящите Общи
          условия, както и за всички вреди вследствие посочване на неверни данни
          или неистинност на декларацията по т. 3.3.2, изречение последно.
          <br />
          12.4. Задълженията на лицата по настоящата т. 12 продължават
          действието си и след прекратяване на договора с ПОТРЕБИТЕЛЯ. <br />
          <br />
          <span>ХІІI. ЗАЩИТА НА ЛИЧНИТЕ ДАННИ</span> <br />
          13.1. Алекс Фиш ООД има право да събира и използва информация относно
          ПОТРЕБИТЕЛИТЕ. Информацията, чрез която лицето може да бъде
          идентифицирано, може да включва име, презиме, фамилия, дата на
          раждане, пол, населено място, електонна поща, както и всяка друга
          информация, която ПОТРЕБИТЕЛЯТ доброволно въвежда, използва или
          предоставя при ползване на Услугите на Уебсайта
          <span> delivery.alexfish.bg</span>. С оглед избягване на всякакво
          съмнение, Потребителското съдържание не се разглежда като лични данни
          и поради това не е предмет на защитата, предоставяна относно личните
          данни на ПОТРЕБИТЕЛЯ съгласно настоящите Общи условия. <br />
          13.2. Всеки регистриран ПОТРЕБИТЕЛ чрез своите потребителско име и
          парола има право на достъп в режим on-line до потребителския си
          профил, където може да поправя и актуализира своите лични данни,
          съхранявани от Алекс Фиш ООД. <br />
          13.3. Фирма „Алекс Фиш ООД е вписана в регистъра на администратори на
          лични данни под номер 19791, съгласно удостоверение от КЗЛД номер
          19791 / 21.10.2010 г. Алекс Фиш ООД полага дължимата грижа за
          събирането, обработването и съхраняването на личните данни на
          ПОТРЕБИТЕЛИТЕ, при стриктно спазване на разпоредбите на Закона за
          защита на личните данни. <br />
          13.4. Алекс Фиш ООД полага дължимата грижа и отговаря за защита на
          информацията за ПОТРЕБИТЕЛЯ, станала му известна по повод на
          предоставяне на Услугите, предмет на тези Общи условия, освен в
          случаите на непреодолима сила, случайно събитие или злоумишлени
          действия на трети лица, както и в случаите, при които ПОТРЕБИТЕЛЯТ сам
          е направил достъпна тази информация за трети лица. <br />
          13.5. В регистрационната форма, попълвана от ПОТРЕБИТЕЛЯ при сключване
          на договора, Алекс Фиш ООД ясно обозначава задължителния или
          доброволния характер на предоставяне на данните и последиците от отказ
          за предоставяне. С изразяване на съгласие с настоящите Общи условия
          ПОТРЕБИТЕЛЯТ се съгласява информацията за него да бъде обработвана по
          предвидения в тях ред. <br />
          13.6. Алекс Фиш ООД събира и използва информацията по т. 13.1 за
          целите, предвидени в настоящите Общи условия, включително за
          предлагане на нови услуги на потребителите, предлагане на оферирани от
          други лица стоки и/или услуги, за промоции, организиране на томболи,
          запитвания, за статистически и всякакви други цели, като с
          регистрирането си за ползване на Услугите, ПОТРЕБИТЕЛЯТ се съгласява
          да получава търговски съобщения, изпращани от Алекс Фиш ООД. Описаните
          цели, за които може да се използва информацията, не са изчерпателно
          изброени и не пораждат задължения за Алекс Фиш ООД. <br />
          13.7. С приемането на настоящите Общи условия, ПОТРЕБИТЕЛЯТ се
          съгласява с обработването на личните му данни за целите на директния
          маркетинг. ПОТРЕБИТЕЛЯТ има право да възрази срещу обработването на
          личните му данни за целите на директния маркетинг, като изпрати
          писмено съобщение до Алекс Фиш ООД на посочените адрес или emai за
          контакти. ПОТРЕБИТЕЛЯТ има право да бъде уведомен преди личните му
          данни да бъдат разкрити за пръв път на трети лица или използвани от
          тяхно име за целите на директния маркетинг като му бъде предоставена
          възможност да възрази срещу такова разкриване или използване. <br />
          13.8. Алекс Фиш ООД се задължава да не редактира или разкрива никаква
          лична информация за ПОТРЕБИТЕЛЯ или за ползването от него на Услугите
          и да не предоставя събраната информация на трети лица – държавни
          органи, търговски дружества, физически лица и други, освен в случаите
          когато: а/ това е предвидено в настоящите Общи условия или
          ПОТРЕБИТЕЛЯТ е дал изричното си съгласие при регистрацията или в
          по-късен момент; б/ това е необходимо за изпълнение на нормативно
          установено задължение на Алекс Фиш ООД; в/ информацията е изискана от
          държавни органи или длъжностни лица, които според действащото
          законодателство са оправомощени да изискват и събират такава
          информация при спазване на законово установените процедури; г/
          информацията относно личните данни се предоставя на служители или
          подизпълнители на Алекс Фиш ООД за дейности по администриране на същия
          и ползването на Услугите; д/ други посочени в закона случаи. <br />
          13.9. При използване на Уебсайта<span> delivery.alexfish.bg</span>,
          Алекс Фиш ООД има правото автоматично да запазва определена
          информация, която компютър или друго крайно устройство на ПОТРЕБИТЕЛЯ
          изпраща към сървър на Алекс Фиш ООД във връзка с активността на
          ПОТРЕБИТЕЛЯ. Информацията се съхранява в лог-файлове на сървъри на
          Алекс Фиш ООД и може да включва IP адреса на ПОТРЕБИТЕЛЯ, дата и час,
          в който е посетена съответната страница от Уебсайта
          <span> delivery.alexfish.bg</span>, времето прекарано на нея и др. В
          допълнение, Алекс Фиш ООД съхранява IP адреса на ПОТРЕБИТЕЛЯ, както и
          всяка друга информация, необходима за идентифициране на ПОТРЕБИТЕЛЯ и
          възпроизвеждане на електронното му изявление по т. 3.2., съответно т.
          3.3.1 за приемане на Общите условия, в случай на възникване на правен
          спор. <br />
          13.10. Алекс Фиш ООД има право, но не и задължение, да инсталира върху
          компютър или друго крайно устройство на ПОТРЕБИТЕЛЯ кукита (cookies) –
          малки текстови файлове, които се запазват от Интернет страница чрез
          Интернет сървър върху твърдия диск на ПОТРЕБИТЕЛЯ и дават възможност
          за възстановяване на информация за ПОТРЕБИТЕЛЯ, като го идентифицират,
          както и за проследяване на действията му. <br />
          <br />
          <span>ХІV. ПРЕКРАТЯВАНЕ И РАЗВАЛЯНЕ НА ДОГОВОРА</span> <br />
          14.1. Освен в случаите, предвидени в настоящите Общи условия,
          договорът между страните се прекратява и при настъпване на някое от
          следните обстоятелства: а/ преустановяване на дейността на Алекс Фиш
          ООД или прекратяване на поддържането на Уебсайта
          <span> delivery.alexfish.bg</span>; б/ взаимно съгласие на страните за
          прекратяването; в/ други предвидени в закона случаи. <br />
          14.2. В случай на прекратяване на договора между страните на каквото и
          да е основание, Алекс Фиш ООД има право да спре незабавно достъпа на
          съответния ПОТРЕБИТЕЛ до потребителския му профил, да прекрати
          регистрацията му и да изтрие от сървърите си цялото разположено от
          него Потребителско съдържание, при спазване на изискванията на
          приложимото законодателство. В случай на прекратяване на договора
          Алекс Фиш ООД не носи отговорност за претърпени вреди и пропуснати
          ползи от ПОРЕБИТЕЛЯ или трети лица, настъпили вследствие на спирането
          на достъпа на ПОТРЕБИТЕЛЯ до потребителския му профил, прекратяването
          на регистрацията му, изтриването на разположеното от ПОТРЕБИТЕЛЯ
          Потребителско съдържание от сървърите на Алекс Фиш ООД, както и
          вследствие предоставянето на информация или изпълнение на
          разпореждания на компетентните държавни органи. <br />
          <br />
          <span>ХV. ДРУГИ УСЛОВИЯ </span>
          <br />
          15.1. Предвидените в договора и настоящите Общи условия писмени или
          елекртонни изявления и съобщения се считат за валидно извършени, ако
          са направени под формата на писмо с обратна разписка, факсимилно
          съобщение, електронна поща, натискане на виртуален бутон в Уебсайта
          <span> delivery.alexfish.bg</span> и други подобни, доколкото
          изявлението е записано технически по начин, който дава възможност да
          бъде възпроизведено.
          <br />
          15.2. С приемане на настоящите Общи условия и сключване на договор
          помежду си, страните изразяват съгласието си да считат отправените
          електронни изявления помежду им за получени с постъпването им в
          посочената от адресата информационна система, без за това да е
          необходимо изрично потвърждаване. Когато Алекс Фиш ООД е адресат на
          изявлението, то за постъпване на изявлението в посочена от адресата
          информационна система се счита постъпването му в POP3 сървърите на
          Алекс Фиш ООД. Когато ПОТРЕБИТЕЛЯТ е адресат на изявлението, то за
          постъпване на изявлението в посочена от адресата информационна система
          се счита постъпването му в посочената при регистрацията му електронна
          пощенска кутия, разположена на сървър в рамките на съответния
          адресиращ кутията домейн. В случай, че ПОТРЕБИТЕЛЯТ е посочил
          невалидна електронна пощенска кутия, то изявлението ще се счита за
          получено само с изпращането му от Алекс Фиш ООД, дори ако не е било
          получено. <br />
          15.3. Страните се съгласяват, че в случай, че някоя от клаузите по
          настоящите Общи условия се окаже недействителна, това няма да влече
          недействителност на договора, на други клаузи или негови части.
          Недействителната клауза ще бъде заместена от повелителните норми на
          закона или установената практика. <br />
          15.4. Уебсайтът<span> delivery.alexfish.bg</span> се поддържа от Алекс
          Фиш ООД посредством техническо оборудване, разположено на територията
          на Република България. Алекс Фиш ООД не гарантира и не носи
          отговорност за достъпността и надлежното предоставяне на Услугите на
          Уебсайта
          <span> delivery.alexfish.bg</span> извън територията на Република
          България, както и в частност населените места в които не се
          осъществява доставка могат да се използват само неплатени услуги. В
          случай, че ПОТРЕБИТЕЛЯТ ползва Услугите, предмет на настоящите Общи
          условия, извън територията на Република България, ПОТРЕБИТЕЛЯТ е
          единствено отговорен за спазване на приложимото законодателство
          съобразно с мястото на ползване на Услугите. <br />
          15.5. За всички неуредени от настоящия договор въпроси се прилагат
          разпоредбите на действащото законодателство на Република България.
          <br />
          15.6. Всички спорове между страните се решават в дух на разбирателство
          и добра воля. В случай, че съгласие не бъде постигнато, всички
          неразрешени спорове, породени от договора между страните или отнасящи
          се до него, включително спорове, породени или отнасящи се до неговото
          тълкуване, недействителност, изпълнение или прекратяване, както и
          спорове за попълване на празноти в договора или приспособяването му
          към нововъзникнали обстоятелства, ще бъдат разрешавани от компетентния
          по действащото българско законодателство съд. <br />
          <br />
          Според действащата законодателна система продажбата на алкохол и
          цигари е забранена за лица под 18-годишна възраст. При съмнение от
          страна на доставчика по време на финализиране и предаване на
          направената поръчка, клиентът се задължава да удостовери и покаже
          личната си карта. <br />В случай, че клиентът е лице под 18-годишна
          възраст, алкохол или цигари няма да бъдат предадени и ще бъдат върнати
          в обслужващо зоната за доставка заведение.
          <br /> В случай, че клиент желае да откаже направена поръчка,това може
          да стане в рамките на 3 минути след приеманието й, и отказът може да
          бъде удовлетворен, след позвъняване на 0700 19 000. <br />
          При отказ от страна на клиент след 3-тата минута същият се добавя в
          база данни „Черен списък” – списък от клиенти, чиито поръчки няма да
          бъдат изпълнявани. <br />
          <br />
          Настоящите Общи условия са приети с решение на ЕСК на "Алекс Фиш ООД"
          ЕООД от 05.07.2010 г. и влизат в сила от 05.07.2010 г. <br />
          Настоящите Общи условия са променени на 02.04.2024г.
        </p>
      </div>
    </section>
  );
}
